import { createContentfulProps } from "frontend/contentful/lib/create-contentful-props";
import { AccordionEntry } from "frontend/contentful/schema/blocks";
import { createComponentHeaderProps } from "../primitives/component-header.props";
import { AccordionProps } from "design-system/components/blocks/accordion/accordion";
import { AccordionOptions } from "./accordion.contentful";
import {
  AccordionItemOptions,
  createAccordionItemProps,
} from "../primitives/accordion-item.props";

export const createAccordionProps = createContentfulProps<
  AccordionEntry,
  AccordionProps,
  AccordionOptions
>(({ entry, options }) => {
  const headerAbove = options?.headerAbove || false;

  const props: AccordionProps = {
    headerContent: createComponentHeaderProps(entry.fields.header),
    align: entry.fields.alignment,
    HeadingLevel: {
      titleHeader: headerAbove ? "h3" : "h2",
      itemHeader:
        headerAbove && entry.fields.header
          ? "h4"
          : headerAbove || entry.fields.header
            ? "h3"
            : "h2",
    },
    items: [],
  };

  entry.fields.accordionItems?.forEach((item) => {
    const itemOptions: AccordionItemOptions = {
      headingLevel:
        headerAbove && entry.fields.header
          ? "h5"
          : headerAbove || entry.fields.header
            ? "h4"
            : "h3",
    };
    const itemProps = createAccordionItemProps(item, itemOptions);

    if (itemProps) props.items?.push(itemProps);
  });

  return props;
});
